const PAGINATION_LIMIT = 10;

export function useMiniToolsQueries() {
  const queryClient = useQueryClient();
  const { aiMiniTools } = useApiClient();

  const useIndexQuery = ({
    page,
    limit,
    query = ref(""),
    category,
    international,
  }: {
    page?: Ref<number>;
    limit?: number;
    query?: Ref<string>;
    category?: Ref<string>;
    international?: Ref<string>;
  }) => {
    return useQuery(
      {
        queryKey: ["mini_tool", page, query, category, international],
        queryFn: () => {
          return aiMiniTools.listAiMiniTools({
            page: (page && page.value) || 1,
            limit: limit || PAGINATION_LIMIT,
            query: query.value,
            category: category?.value,
            international: international?.value,
          });
        },
        placeholderData: keepPreviousData,
      },
      queryClient
    );
  };

  const useFeaturedQuery = (
    {
      international,
      page,
      limit = 3,
    }: {
      international?: Ref<string>;
      page?: number;
      limit: number;
    },
    opts = {}
  ) => {
    return useQuery(
      {
        queryKey: ["mini_tool", "featured", page, limit, international],
        queryFn: () => {
          return aiMiniTools.listFeaturedAiMiniTools({
            page,
            limit,
            international: international?.value,
          });
        },
        placeholderData: keepPreviousData,
        ...opts,
      },
      queryClient
    );
  };

  const getQuery = (id: Ref<string>, options = {}) => {
    return useQuery(
      {
        queryKey: ["mini_tool", id],
        queryFn: () => aiMiniTools.getAiMiniTool({ id: id.value }),
        ...options,
      },
      queryClient
    );
  };

  return { useIndexQuery, useFeaturedQuery, getQuery };
}
